export default {
  getColumnHeaders: function() {
    return this.columnHeaders[this.index]
  },
  getRowHeaders: function() {
    return this.rowHeaders[this.index]
  },
  makeHeader: function(count) {
    let headers = [...Array(count).keys()]
    return headers.map(header => { return { data: { value: header, text: header + 1 } } })
  },
}